import styled from 'styled-components';
import colors from '../../includes/colors';

const InputWithImage = styled.div`
  div {
    position: absolute;
    right: 10px;
    bottom: 20px;
    font-size: 33px;
    color: ${colors.strongGray};
    cursor: pointer;

    @media (min-width: 576px) {
      bottom: 35px;
    }

    :hover {
      color: ${colors.darkBlue};
    }
  }

  input {
    padding-right: 40px;
  }
`;

export { InputWithImage };
